import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.adminReviews;

export const adminReviewsSelector = createSelector(getState, (state) => state.reviews);
export const adminReviewsMetaSelector = createSelector(getState, (state) => state.reviewsMeta);
export const isLoadingReviewsSelector = createSelector(getState, (state) => state.isLoadingReviews);

export const selectedAdminReviewSelector = createSelector(
  getState,
  (state) => state.selectedReview,
);
export const isLoadingAdminReviewSelector = createSelector(
  getState,
  (state) => state.isLoadingReview,
);

export const adminReviewErrorsSelector = createSelector(getState, (state) => state.errors);
